import {Company, User, userMatchesSSOHubblFilters} from 'hubbl-shared';
import {HubblBreakDTO, HubblGroupDTO} from '../../models';
import {isUserInvited} from '../../utils';

export const filterIncomingPendingHubbles = <
  T extends HubblBreakDTO | HubblGroupDTO,
>(
  loggedInUser: User,
  pendingHubbles: T[],
  company?: Company,
) => {
  return pendingHubbles.filter(hubbl => {
    // Invitation check
    if (!hubbl.invitedUsers || hubbl.invitedUsers.length === 0) {
      // Continue to filter check
    } else if (isUserInvited(hubbl.invitedUsers)) {
      return true;
    } else {
      return false;
    }

    // Filter check
    if (hubbl.filters?.length) {
      // Legacy department check
      if (
        hubbl.filters.some(
          f => f.type === 'department' && f.id === loggedInUser.department.id,
        )
      ) {
        return true;
      }
      // SSO hierarchical filter check
      // Only pass non-department filters to userMatchesSSOHubblFilters
      const ssoFilters = hubbl.filters.filter(f => f.type !== 'department');
      if (ssoFilters.length > 0) {
        if (
          userMatchesSSOHubblFilters(
            loggedInUser.customSSOProperties,
            ssoFilters,
            company?.organizationalMetadata,
          )
        ) {
          return true;
        }
      }
      return false;
    }
    return true;
  });
};
